@if (list.length > 0) {
  <div class="income-list">
    <ul class="income-list__list">
      <li class="income-list__list--header">
        @if (incomeType === 'incomes') {
          <p class="type">{{ "PRICE_TYPES.INCOME" | translate }}</p>
        }
        @if (incomeType === 'costs') {
          <p class="type">{{ "PRICE_TYPES.COSTS" | translate }}</p>
        }
        <div class="price-types">
          @if (incomeType === 'incomes') {
            <p class="vat">{{ "PRICE_TYPES.VAT" | translate }}</p>
          }
          @if (incomeType === 'incomes') {
            <p class="net">{{ "PRICE_TYPES.NET" | translate }}</p>
          }
          @if (incomeType === 'incomes') {
            <p class="gross">{{ "PRICE_TYPES.GROSS" | translate }}</p>
          }
        </div>
      </li>
      @for (element of list; track element; let i = $index) {
        <li class="income-list__list--element">
          <div class="income-list__info desktop">
            <span class="name">{{ i + 1 }}. {{ displayName(element.name) }}</span>
            @if (!isEditVisible[i] && !!element.value) {
              <button
                class="action add"
                (click)="handleEdit(i)"
                >Edytuj</button
                >
              } @else {
                <button class="action remove" (click)="removeValue(i)"></button>
              }
              <div class="action-container">
                @if (!isEditVisible[i] && !!element.value) {
                  @if (incomeType === 'incomes') {
                    <span class="price vat">{{ displayVat(i) }}</span>
                  }
                  @if (incomeType === 'incomes') {
                    <span class="price net">{{ displayNet(i) }}</span>
                  }
                  <span class="price gross">{{ displayGross(i) }}</span>
                }
              </div>
            </div>
            <div class="income-list__info mobile">
              <span class="name"
                >{{ displayName(element.name) }}
                @if (isEditVisible[i]) {
                  <button class="action remove" (click)="removeValue(i)"></button
                    >
                  }</span>
                  @if (!isEditVisible[i] && !!element.value) {
                    <div class="values-container">
                      <div class="price-types">
                        @if (incomeType === 'incomes' && hasVatValue(i)) {
                          <p class="vat">{{ "PRICE_TYPES.VAT" | translate }}</p>
                        }
                        @if (incomeType === 'incomes' && hasVatValue(i)) {
                          <p class="net">{{ "PRICE_TYPES.NET" | translate }}</p>
                        }
                        @if (incomeType === 'incomes' && hasVatValue(i)) {
                          <p class="gross">{{
                            "PRICE_TYPES.GROSS" | translate
                          }}</p>
                        }
                        @if (incomeType === 'incomes' && !hasVatValue(i)) {
                          <p class="gross">{{ "PRICE_TYPES.SUM" | translate }}</p>
                        }
                      </div>
                      <div class="action-container" [class.no-vat]="!hasVatValue(i)">
                        <!-- <ng-template #removeAction>
                        <button class="action remove" (click)="removeValue(i)"></button>
                      </ng-template> -->
                      <ng-container>
                        @if (incomeType === 'incomes' && hasVatValue(i)) {
                          <span class="price vat">{{ displayVat(i) }}</span>
                        }
                        @if (incomeType === 'incomes' && hasVatValue(i)) {
                          <span class="price net">{{ displayNet(i) }}</span>
                        }
                        <span class="price gross">{{ displayGross(i) }}</span>
                      </ng-container>
                    </div>
                  </div>
                }
                @if (!isEditVisible[i] && !!element.value) {
                  <button class="action add" (click)="handleEdit(i)">Edytuj</button>
                }
              </div>
              <!-- EDIT INPUT PLACE -->
              <div class="edit-data" [ngClass]="{ show: isEditVisible[i] }">
                <app-income-edit
                  [value]="element"
                  [btnTextFirst]="btnTextFirst"
                  [btnTextSecond]="btnTextSecond"
                  (hideEdit)="handleEdit($event)"
                  [editIndex]="i"
                  [list]="list"
                  [inputLabel]="inputLabel"
                  [inputPlaceholder]="inputPlaceholder"
                  [vatInputLabel]="vatInputLabel"
                  [vatInputPlaceholder]="vatInputPlaceholder"
                  [alertInfo]="alertInfo"
                  [incomeType]="incomeType"
                ></app-income-edit>
              </div>
            </li>
          }
        </ul>
        @if (!isLump) {
          <div class="income-list__summary">
            <span class="income-list__summary--title">Podsumowanie</span>
            <span class="income-list__summary--value">{{ summary() }}</span>
          </div>
        }
      </div>
    }
